import React from 'react';

import { AspectRatio, Stack, useMantineTheme } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { ErrorAlert } from 'components/ErrorAlert';
import { FullScreenLoader } from 'components/FullScreenLoader';
import { ResourceViewerWrapper } from 'components/ResourceViewerWrapper/ResourceViewerWrapper';
import { useParams } from 'react-router';
import { ResourceService } from 'services/resource-service';
import { RESOURCE_QUERY_KEY } from 'shared/constants/query-keys';

export function YoutubeViewerPage() {
  const theme = useMantineTheme();
  const { resourceId } = useParams();

  if (!resourceId) return <ErrorAlert />;

  const resourceQuery = useQuery({
    queryKey: [RESOURCE_QUERY_KEY, { resourceId }],
    queryFn: () => ResourceService.getResourceInfo(resourceId),
    refetchOnWindowFocus: false
  });

  if (resourceQuery.isLoading || !resourceQuery.data) return <FullScreenLoader />;
  if (resourceQuery.isError) return <ErrorAlert />;

  return (
    <ResourceViewerWrapper
      resourceId={resourceId}
      fileName={resourceQuery.data?.fileName}
      backgroundColor={theme.colors.gray[0]}>
      <Stack justify="center" align="center" p={48} style={{ flex: 1 }}>
        <AspectRatio maw={900} w="100%" ratio={16 / 9}>
          <iframe
            style={{
              border: 'none',
              borderRadius: '12px',
              backgroundColor: 'white',
              width: '100%',
              height: '100%'
            }}
            src={`https://www.youtube.com/embed/${resourceQuery.data.youtubeVideoId}`}
            title={resourceQuery.data.fileName}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </AspectRatio>
      </Stack>
    </ResourceViewerWrapper>
  );
}
